import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-gradient-to-b from-navy-900 to-navy-800 flex items-center justify-center px-4 py-20" data-id="element-70">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center md:text-left" data-id="element-72">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-73">
            Detén el ruido mental y duerme en menos de{' '}
            <span className="text-gold" data-id="element-74">12 minutos</span> con el "Protocolo SOS
            Chino"
          </h1>
          <h2 className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-75">
            El método milenario basado en la Medicina Tradicional China para
            apagar tu sistema nervioso de forma manual, sin usar fármacos ni
            melatonina.
          </h2>
          <motion.a href="#oferta" whileHover={{
          scale: 1.05,
          boxShadow: '0 0 30px rgba(212, 175, 55, 0.5)'
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold text-navy-900 font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 cursor-pointer" data-id="element-76">
            ¡QUIERO DORMIR BIEN AHORA!
          </motion.a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex justify-center" data-id="element-77">
          <img src="https://cdn.magicpatterns.com/uploads/eQw2E1bJPnFm8dfpxNRBr7/insonio_chino.png" alt="Protocolo SOS: Insomnio Chino" className="w-full max-w-md rounded-lg shadow-2xl" data-id="element-78" />
        </motion.div>
      </div>
    </section>;
}